import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth.js';
export const GuestGuard = ({ children, onAuthenticated }) => {
    const { isAuthenticated, isLoading, isError } = useAuth();
    useEffect(() => {
        // 仅在非加载、非错误且已认证时，才触发已认证回调
        if (!isLoading && isAuthenticated && !isError) {
            onAuthenticated?.();
        }
    }, [isAuthenticated, isLoading, isError, onAuthenticated]);
    // 在加载或已认证时，显示一个占位符以防止布局闪烁
    if (isLoading || isAuthenticated) {
        // 理想情况下，这里应该是一个全局的、居中的加载动画组件
        // 为了快速修复，我们先用一个简单的div撑开高度
        return _jsx("div", { className: "min-h-screen" });
    }
    if (isError) {
        // 错误情况可以快速失败，或者显示一个错误信息组件
        return null;
    }
    // 只有在完全确认未认证后才渲染子组件
    return _jsx(_Fragment, { children: children });
};
//# sourceMappingURL=GuestGuard.js.map